/**
 * LightningBolt — brand mark for LightningFlow.
 *
 * Uses the official blue bolt asset (`/brand/lightningflow-bolt-20261018.png`, transparent background).
 * The optional `withHalo` prop adds a soft cyan glow ring behind the mark for
 * hero/login placements.
 */
export function LightningBolt({ size = 24, withHalo = false, className = "" }) {
  const px = typeof size === "number" ? `${size}px` : size;

  const img = (
    <img
      src="/brand/lightningflow-bolt-20261018.png"
      alt=""
      width={typeof size === "number" ? size : undefined}
      style={{ width: px, height: "auto", objectFit: "contain" }}
      className={`block select-none ${className}`}
      draggable={false}
      aria-hidden="true"
    />
  );

  if (!withHalo) return img;

  return (
    <span
      className="relative inline-flex items-center justify-center"
      style={{ width: `calc(${px} * 2.2)`, height: `calc(${px} * 2.2)` }}
      aria-hidden="true"
    >
      <span
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(56,189,248,0.45), rgba(56,189,248,0.15) 45%, transparent 70%)",
          filter: "blur(2px)",
        }}
      />
      {img}
    </span>
  );
}

export default LightningBolt;
